import(/* webpackMode: "eager", webpackExports: ["Label"] */ "/vercel/path0/apps/web/src/components/ui/label.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RadioGroup","RadioGroupItem"] */ "/vercel/path0/apps/web/src/components/ui/radio-group.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs","TabsList","TabsTrigger","TabsContent"] */ "/vercel/path0/apps/web/src/components/ui/tabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.5.14_@opentelemetry+api@1.9.0_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/app-dir/link.js");
